'use strict';

var React = require('react');

var SvgGrammarMajor = function SvgGrammarMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 2.5a1.5 1.5 0 0 0-1.5-1.5h-15a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h6.5a1 1 0 0 0 0-2h-6v-14h14v8a1 1 0 1 0 2 0v-8.5zm-5 8.5h-8v-2h8v2zm-8 4v-2h4v2h-4zm0-10v2h8v-2h-8zm12.293 9.293-3.293 3.293-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414z"
  }));
};

exports.SvgGrammarMajor = SvgGrammarMajor;
